<template>
  <modal
    @before-close="modalClose"
    :name="modal"
    :adaptive="true"
    :reset="true"
    width="450"
    :scrollable="false"
    :height="'auto'"
  >
    <card>
      <p>{{ client.full_name }}</p>

      <p>{{ table.date | dateFormat }}</p>
      <hr />
      <selector
        :disabled="value.id != null"
        v-model="value.work"
        :title="`Задание`"
        :prefix="`work_${table.lessonplan.id}`"
        :modal="`work`"
        :params="{ lessonplan_id: table.lessonplan.id }"
        :selectKey="`title`"
        :setLink="`business/timetables/${table.id}/works`"
      />
      
      <div class="flex ai-center m-b-4">
        <div class="p-r-3">
          Выберите оценку:
        </div>
        <ul class="rating-list">
          <li 
            v-for="(item, key) in ratingSteps" :key="key" 
            :class="[
              {'active': value.value == item.value},
              `type_${item.value}`
            ]"
            >
            <label>
              <input 
              type="radio" 
              name="rating"
              class="hide"
              v-model="value.value" :value="item.value" @change="updateRating" >
              <span class="input-content">{{item.value}}</span>
            </label>
          </li>
        </ul>
      </div>

      <!-- <star-rating
        v-if="value.work && value.work.id"
        :star-size="30"
        v-model="value.value"
        @rating-selected="updateRating"
      ></star-rating> -->
      <br />

      <button
        v-if="value.id"
        @click="deleteRating"
        class="btn btn-sm btn-danger mr-2 m-b-4"
      >
        {{ "delete" | setText("Удалить") }}
      </button>
    </card>
  </modal>
</template>

<script>
export default {
  created() {
    // if (
    //   this.value &&
    //   this.value.work &&
    //   !this.value.work.id &&
    //   this.table.lessonplan.works.length
    // ) {
    //   this.value.work = this.table.lessonplan.works[0];
    // }
  },
  data() {
    return {
      ratingSteps: [
        {
          color: "#FF4C00",
          value: 1
        },
        {
          color: "#D75D5D",
          value: 2
        },
        {
          color: "#F5BF33",
          value: 3
        },
        {
          color: "#33C7F5",
          value: 4
        },
        {
          color: "#A1D75D",
          value: 5
        },
      ]
    };
  },
  props: ["client", "value", "table", "modal", "getJournal"],

  methods: {
    updateRating() {
      this.$loading(true);

      this.$http
        .post(`business/ratings`, {
          timetable_id: this.table.id,
          client: this.client,
          value: this.value.value,
          work: this.value.work,
        })
        .then((response) => {
          this.$modal.hide(this.modal);
        })
        .catch((error) => {})
        .finally(() => {
          setTimeout(() => {
            this.getJournal();
          }, 10);
        });
    },
    deleteRating() {
      this.$loading(true);

      this.$http
        .delete(`business/ratings/${this.value.id}`)
        .then((response) => {
          this.$emit("close", true);
          // this.$emit('deleteRating', response.data.data);
        })
        .catch((error) => {})
        .finally(() => {
          setTimeout(() => {
            this.getJournal();
          }, 10);
        });
    },
    modalClose() {
      this.$emit("close", true);
    },
  },
};
</script>

<style lang="scss">
</style>

